import { useEffect, useState } from 'react'

import { HourglassIcon } from '@hugeicons/react'
import Countdown from 'react-countdown'

import { useDigitalProductStore } from '../hook'
import { StoreStatusPanel } from './StoreStatusPanel'

const pad = value => String(value).padStart(2, '0')

const formatCountdown = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) return null

  const clock = [hours, minutes, seconds].map(pad).join(':')
  return days > 0 ? `${days}d ${clock}` : clock
}

export const DigitalProductStoreAlertsOpenSoon = ({ onOpen }) => {
  const { openingHours } = useDigitalProductStore()

  const [opening, setOpening] = useState(
    () => openingHours.openAt.toMillis() <= Date.now()
  )

  const handleComplete = () => {
    setOpening(true)
    onOpen()
  }

  useEffect(() => {
    if (opening) onOpen()
  }, [opening, onOpen])

  if (opening) {
    return (
      <StoreStatusPanel
        icon="shop"
        badge={
          <>
            <HourglassIcon size={14} aria-hidden />
            Abrindo agora
          </>
        }
        title={
          <h2 className="m-0 text-xl font-extrabold leading-snug text-gray-900">
            Preparando a lojinha
          </h2>
        }
        description="Estamos liberando suas recompensas. Só um instante."
        footer={
          <div className="flex items-center justify-center gap-2 text-sm font-semibold text-gray-700">
            <span
              className="inline-block size-4 animate-spin rounded-full border-2 border-brand border-t-transparent"
              aria-hidden
            />
            Carregando itens disponíveis
          </div>
        }
      />
    )
  }

  return (
    <StoreStatusPanel
      icon="history"
      badge={
        <>
          <HourglassIcon size={14} aria-hidden />
          Em breve
        </>
      }
      title={
        <div className="flex flex-col items-center gap-2">
          <h2 className="m-0 text-xl font-extrabold leading-snug text-gray-900">
            A lojinha ainda não abriu
          </h2>
          <p className="m-0 text-3xl font-extrabold tracking-tight text-brand tabular-nums">
            <Countdown
              date={openingHours.openAt.toJSDate()}
              zeroPadTime={2}
              renderer={formatCountdown}
              onComplete={handleComplete}
            />
          </p>
        </div>
      }
      description="Você poderá reservar suas recompensas assim que a lojinha estiver aberta. Os itens aparecerão aqui automaticamente."
    />
  )
}
